import React from 'react';
import { Button } from '@mui/material';

function PrimaryActionButton({ children, sx = {}, ...props }) {
  return (
    <Button
      variant="contained"
      size="large"
      color="primary"
      sx={{
        minWidth: 180,
        borderRadius: 1,
        py: 1,
        px: 3,
        fontWeight: 600,
        fontSize: 16,
        letterSpacing: 0,
        textTransform: 'inherit',
        boxShadow: 2,
        ...sx,
      }}
      {...props}
    >
      {children}
    </Button>
  );
}

export default PrimaryActionButton;
